var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRealestate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "black",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.136V2L16 2.75L30 8V28V30H28H16H14H4H2V28V13L14 8.71429V4.136ZM16 8V10.1237V16V28H28V9.386L16 4.886V8ZM14 10.838L4 14.4094V28H14V16V10.838Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9969 19.0049h6v2H5.9969Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9969 15.0092h6v2H5.9969Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9969 23.0227h6v2H5.9969Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.0092h6v2H19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23.0227h6v2H19Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.0049h6v2H19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.0045h6v2H19Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRealestate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/realestate.2299b6dc.svg";
export { ForwardRef as ReactComponent };